<template>
    <div :class="divName">
        <Header v-if="header === true"></Header>
        <keep-alive :include="include" :max="10">
            <router-view
                class="router-view"
                ref="router"
                v-if="$route.meta.keepAlive"
            ></router-view>
        </keep-alive>
        <router-view class="router-view" ref="router" v-if="!$route.meta.keepAlive"></router-view>
        <Footer v-if="footer === true"></Footer>
        <LoadPage v-if="isLoading"></LoadPage>

        <Home v-if="isShowHome"></Home>
    </div>
</template>
<script>
function isKeepAlive($route) {
    return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}

import Footer from '@components/Footer';
import Header from '@components/Header';
import LoadPage from '@components/LoadPage';
import { mapGetters } from 'vuex';
import Home from '@components/Home';
import { isWeixin } from '@utils';
import { wechatEvevt } from '@libs/wechat';
import { getShare } from '@api/public';
export default {
    data() {
        return {
            include: isKeepAlive(this.$route) ? [this.$route.name] : [],
            history: [],
            isFooter: false
        };
    },
    provide() {
        return {
            app: this
        };
    },
    computed: {
        ...mapGetters(['footer', 'home', 'isLogin', 'header', 'homeActive', 'isLoading']),
        divName() {
            let name = '';
            if (this.$route.name != null) {
                name = this.$route.name;
            }
            return name.toLowerCase();
        },
        isShowHome() {
            let show = true;
            if (
                this.$route.name === 'Index' ||
                this.$route.name === 'User' ||
                this.$route.name === 'Classroom'
            ) {
                show = false;
            }
            return show;
        }
    },
    components: {
        Footer,
        Header,
        LoadPage,
        Home
    },
    watch: {
        $route(to, from) {
            const lastPath = this.history[this.history.length - 1] || {},
                { isReplace, isBack } = this.$router;
            this.isFooter = to.meta.footer || false;
            let isRouterBack = isBack ? true : false;
            if (lastPath.path === to.path) {
                this.history.pop();
                this.$router.isBack = true;
                isRouterBack = true;
            } else {
                if (!isReplace) this.history.push({ path: from.path, name: from.name });
            }

            if (isKeepAlive(to) && to.name !== 'Login') {
                !this.include.includes(to.name) && this.include.push(to.name);
            }

            if (isKeepAlive(from) && isRouterBack) {
                var index = this.include.indexOf(from.name);
                index !== -1 && this.include.splice(index, 1);
            }

            this.$router.isBack = false;
            this.$router.isReplace = false;
            document.getElementsByTagName('body')[0].className = this.divName;
        }
    },
    mounted: function() {
        this.isFooter = this.$route.meta.footer || false;
        document.getElementsByTagName('body')[0].className = this.divName;
        this.setOpenShare();
    },
    methods: {
        setOpenShare: function() {
            if (isWeixin()) {
                getShare().then(res => {
                    var data = res.data.data;
                    var configAppMessage = {
                        desc: data.desc,
                        title: data.title,
                        link: location.href,
                        imgUrl: data.img
                    };
                    wechatEvevt(
                        ['updateAppMessageShareData', 'updateTimelineShareData'],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                            console.log('微信分享设置完成');
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                            }
                        });
                });
            }
        }
    }
};
</script>
<style lang="scss">
[v-cloak] {
    display: none !important;
}

.router {
    // position: absolute;
    width: 100%;
}
</style>
